export default __webpack_public_path__ + "static/media/iconeOrganismoCertificador.b73563d1.svg";